/* src/components/Lang/Localized.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	attr,
	check_outros,
	children,
	claim_element,
	claim_space,
	claim_text,
	component_subscribe,
	create_slot,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	noop,
	outro_and_destroy_block,
	safe_not_equal,
	set_data,
	space,
	text as text_1,
	transition_in,
	transition_out,
	update_keyed_each,
	update_slot
} from "../../_snowpack/pkg/svelte/internal.js";

import { createLocalization } from "./index.js";
import { getContext } from "../../_snowpack/pkg/svelte.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[12] = list[i];
	return child_ctx;
}

const get__2_slot_changes = dirty => ({});
const get__2_slot_context = ctx => ({});
const get__1_slot_changes = dirty => ({});
const get__1_slot_context = ctx => ({});
const get__0_slot_changes = dirty => ({});
const get__0_slot_context = ctx => ({});

// (38:8) {:else}
function create_else_block(ctx) {
	let t_value = /*piece*/ ctx[12] + "";
	let t;

	return {
		c() {
			t = text_1(t_value);
		},
		l(nodes) {
			t = claim_text(nodes, t_value);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*pieces*/ 2 && t_value !== (t_value = /*piece*/ ctx[12] + "")) set_data(t, t_value);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (36:34) 
function create_if_block_3(ctx) {
	let current;
	const _2_slot_template = /*#slots*/ ctx[10]["2"];
	const _2_slot = create_slot(_2_slot_template, ctx, /*$$scope*/ ctx[9], get__2_slot_context);

	return {
		c() {
			if (_2_slot) _2_slot.c();
		},
		l(nodes) {
			if (_2_slot) _2_slot.l(nodes);
		},
		m(target, anchor) {
			if (_2_slot) {
				_2_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (_2_slot) {
				if (_2_slot.p && dirty & /*$$scope*/ 512) {
					update_slot(_2_slot, _2_slot_template, ctx, /*$$scope*/ ctx[9], dirty, get__2_slot_changes, get__2_slot_context);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(_2_slot, local);
			current = true;
		},
		o(local) {
			transition_out(_2_slot, local);
			current = false;
		},
		d(detaching) {
			if (_2_slot) _2_slot.d(detaching);
		}
	};
}

// (34:34) 
function create_if_block_2(ctx) {
	let current;
	const _1_slot_template = /*#slots*/ ctx[10]["1"];
	const _1_slot = create_slot(_1_slot_template, ctx, /*$$scope*/ ctx[9], get__1_slot_context);

	return {
		c() {
			if (_1_slot) _1_slot.c();
		},
		l(nodes) {
			if (_1_slot) _1_slot.l(nodes);
		},
		m(target, anchor) {
			if (_1_slot) {
				_1_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (_1_slot) {
				if (_1_slot.p && dirty & /*$$scope*/ 512) {
					update_slot(_1_slot, _1_slot_template, ctx, /*$$scope*/ ctx[9], dirty, get__1_slot_changes, get__1_slot_context);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(_1_slot, local);
			current = true;
		},
		o(local) {
			transition_out(_1_slot, local);
			current = false;
		},
		d(detaching) {
			if (_1_slot) _1_slot.d(detaching);
		}
	};
}

// (32:8) {#if piece === '{0}'}
function create_if_block_1(ctx) {
	let current;
	const _0_slot_template = /*#slots*/ ctx[10]["0"];
	const _0_slot = create_slot(_0_slot_template, ctx, /*$$scope*/ ctx[9], get__0_slot_context);

	return {
		c() {
			if (_0_slot) _0_slot.c();
		},
		l(nodes) {
			if (_0_slot) _0_slot.l(nodes);
		},
		m(target, anchor) {
			if (_0_slot) {
				_0_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (_0_slot) {
				if (_0_slot.p && dirty & /*$$scope*/ 512) {
					update_slot(_0_slot, _0_slot_template, ctx, /*$$scope*/ ctx[9], dirty, get__0_slot_changes, get__0_slot_context);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(_0_slot, local);
			current = true;
		},
		o(local) {
			transition_out(_0_slot, local);
			current = false;
		},
		d(detaching) {
			if (_0_slot) _0_slot.d(detaching);
		}
	};
}

// (31:4) {#each pieces as piece (piece)}
function create_each_block(key_2, ctx) {
	let first;
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_1, create_if_block_2, create_if_block_3, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*piece*/ ctx[12] === "{0}") return 0;
		if (/*piece*/ ctx[12] === "{1}") return 1;
		if (/*piece*/ ctx[12] === "{2}") return 2;
		return 3;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		key: key_2,
		first: null,
		c() {
			first = empty();
			if_block.c();
			if_block_anchor = empty();
			this.h();
		},
		l(nodes) {
			first = empty();
			if_block.l(nodes);
			if_block_anchor = empty();
			this.h();
		},
		h() {
			this.first = first;
		},
		m(target, anchor) {
			insert(target, first, anchor);
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(first);
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (43:0) {#if false}
function create_if_block(ctx) {
	let current;
	const default_slot_template = /*#slots*/ ctx[10].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[9], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		l(nodes) {
			if (default_slot) default_slot.l(nodes);
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && dirty & /*$$scope*/ 512) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[9], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let each_blocks = [];
	let each_1_lookup = new Map();
	let t;
	let if_block_anchor;
	let current;
	let each_value = /*pieces*/ ctx[1];
	const get_key = ctx => /*piece*/ ctx[12];

	for (let i = 0; i < each_value.length; i += 1) {
		let child_ctx = get_each_context(ctx, each_value, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block(key, child_ctx));
	}

	let if_block = false && create_if_block(ctx);

	return {
		c() {
			div = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(div_nodes);
			}

			div_nodes.forEach(detach);
			t = claim_space(nodes);
			if (if_block) if_block.l(nodes);
			if_block_anchor = empty();
			this.h();
		},
		h() {
			attr(div, "class", /*className*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, div, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div, null);
			}

			insert(target, t, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (dirty & /*$$scope, pieces*/ 514) {
				each_value = /*pieces*/ ctx[1];
				group_outros();
				each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, div, outro_and_destroy_block, create_each_block, null, get_each_context);
				check_outros();
			}

			if (!current || dirty & /*className*/ 1) {
				attr(div, "class", /*className*/ ctx[0]);
			}

			if (false) if_block.p(ctx, dirty);
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			transition_in(if_block);
			current = true;
		},
		o(local) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d();
			}

			if (detaching) detach(t);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

const groupRegex = /({\d+}|.+?(?={\d+})|.+$)/g;

function instance($$self, $$props, $$invalidate) {
	let localization;
	let localize;
	let text;
	let pieces;
	let $lang;
	let { $$slots: slots = {}, $$scope } = $$props;
	const lang = getContext("lang");
	component_subscribe($$self, lang, value => $$invalidate(6, $lang = value));
	let { key = "" } = $$props;
	let { fallbackKey = undefined } = $$props;
	let { class: className = "" } = $$props;

	/**
 * @param {string} text
 */
	function splitString(text) {
		return Array.from(text.matchAll(groupRegex), result => result[0]);
	}

	$$self.$$set = $$props => {
		if ("key" in $$props) $$invalidate(3, key = $$props.key);
		if ("fallbackKey" in $$props) $$invalidate(4, fallbackKey = $$props.fallbackKey);
		if ("class" in $$props) $$invalidate(0, className = $$props.class);
		if ("$$scope" in $$props) $$invalidate(9, $$scope = $$props.$$scope);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$lang*/ 64) {
			$: $$invalidate(5, localization = createLocalization($lang));
		}

		if ($$self.$$.dirty & /*localization*/ 32) {
			$: $$invalidate(7, localize = localization.localize);
		}

		if ($$self.$$.dirty & /*localize, key, fallbackKey*/ 152) {
			$: $$invalidate(8, text = localize(key, fallbackKey));
		}

		if ($$self.$$.dirty & /*text*/ 256) {
			$: $$invalidate(1, pieces = splitString(text));
		}
	};

	return [
		className,
		pieces,
		lang,
		key,
		fallbackKey,
		localization,
		$lang,
		localize,
		text,
		$$scope,
		slots
	];
}

class Localized extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { key: 3, fallbackKey: 4, class: 0 });
	}
}

export default Localized;
//# sourceMappingURL=Localized.svelte.js.map
